<template>
  <div class="task-complete">
    <!-- 头部 -->
    <div class="complete-header" @click="toggleExpand">
      <div class="header-left">
        <img
          :src="cdnUrl + 'ai-thank-icon.svg'"
          alt="思考完成"
          class="complete-icon"
        />
        <span class="complete-text">已完成</span>
      </div>
      <div class="header-right">
        <img
          :src="cdnUrl + (expanded ? 'ai-dowm-icon.svg' : 'ai-right-icon.svg')"
          alt="展开/收起"
          class="expand-icon"
        />
      </div>
    </div>

    <!-- 内容 -->
    <div v-show="expanded" class="complete-content">
      <div class="content-row">
        <img :src="cdnUrl + 'ai-thank-success.svg'" class="row-icon" />
        <span class="row-text">任务已创建</span>
      </div>

      <div class="content-list">
        <li>
          <span class="list-label">活动ID：</span>
          <span class="list-value activity-id" @click="clickActivityId">{{
            packs.marketingId
          }}</span>
        </li>
        <li>
          <a :href="packs.editUrl" target="_blank" class="list-link"
            >在编辑页打开>></a
          >
        </li>
      </div>

      <div class="content-tip">
        任务以草稿状态保存，你可以在编辑页页面查看详情，调整内容及执行投放
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TaskComplete",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      cdnUrl: "https://cdn-image.yucrm.cn/images/tb-front-platform/images/ai/",
      expanded: true,
    };
  },
  computed: {
    packs() {
      if (this.item.agentBiDataJson) {
        return JSON.parse(this.item.agentBiDataJson || "{}");
      }
      return JSON.parse(this.item.packs || "{}");
    },
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
    },
    clickActivityId() {
      const routeUrl = this.$router.resolve({
        path: "/marketing/intelligent_market",
        query: {
          activityId: this.packs.marketingId,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.task-complete {
  width: 100%;
  border: 1px solid #e9e9e9;
  border-radius: 12px;
  overflow: hidden;
  background-color: #ffffff;
  margin-bottom: 8px;
}

/* 头部 */
.complete-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;

  .header-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .complete-icon {
    width: 20px;
    height: 20px;
  }

  .complete-text {
    font-size: 14px;
    color: #999999;
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .success-check {
    width: 20px;
    height: 20px;
  }

  .expand-icon {
    width: 16px;
    height: 16px;
    transition: transform 0.2s;
  }
}

/* 内容 */
.complete-content {
  padding: 0px 16px 16px;

  .content-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;

    .row-icon {
      width: 16px;
      height: 16px;
    }

    .row-text {
      font-size: 14px;
      color: #333333;
    }
  }

  .content-list {
    margin: 0;

    li {
      font-size: 14px;
      list-style-type: disc;

      .list-label {
        color: #333333;
      }

      .list-value {
        color: #3159ff;

        &.activity-id {
          background: #e8f0ff;
          padding: 2px 8px;
          border-radius: 4px;
          cursor: pointer;
        }
      }

      .list-link {
        color: #3159ff;
        text-decoration: none;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .content-tip {
    font-size: 14px;
    color: #999999;
  }
}
</style>
